import * as React from "react";
import {CSSProperties} from "react";


import {StoreControl, StoreControlProps, StoreControlState} from "../../base/StoreControl";
import {ValidatorBase} from "../../../utilities/validator/ValidatorBase";
import {ReactUtilities} from "../../../utilities/react/ReactUtilities";
import {StoreBase} from "shared/core/Store/StoreBase";


export class RNTextArea<S extends StoreBase> extends StoreControl<RNTextAreaProps<S>, RNTextInputState> {
    static defaultProps: Partial<RNTextAreaProps<any>> = {
        height:'auto'
    };

    constructor(props: RNTextAreaProps<S>) {
        super(props);
        this.state={
            IsValid:true,
            ErrorMessage:''
        }
    }

    public render() {
        return (
            <div className={'rncontrol'} style={this.props.style}>
                <div>
                    <label style={{width:'100%',display:'block'}}>{this.props.Label}</label>
                    <textarea style={{height:this.props.height,...this.props.inputStyle}}  disabled={this.props.disabled} className={'rncontrol'} value={this.GetStringValue()} onChange={(e)=>{this.SetValue(e.target.value);ReactUtilities.ExecuteMethodPropIfDefined(this.props.onChange,e.target.value)}}/>
                    {this.GetValidationSection()}
                </div>
            </div>
        )
    }

    GetValidators(): ValidatorBase[] {
        return [];
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface RNTextAreaProps<S extends StoreBase> extends StoreControlProps<S>{
    style?:CSSProperties;
    Label:string;
    disabled?:boolean;
    height:any;
    onChange?:(value:string)=>void;
    inputStyle?:CSSProperties;
}

interface RNTextInputState extends StoreControlState{

}

//#endregion "My Region"